"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.COMPONENT_NAME = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.text-info"));
var _gerenciatdUnifiedcomponents2 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.button"));
var _gerenciatdUnifiedcomponents3 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.image"));
var _gerenciatdUnifiedcomponents4 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.modal-atencion-emp"));
require("./CounselingContact.scss");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const COMPONENT_NAME = exports.COMPONENT_NAME = 'counseling-contact';
const CounselingContact = props => {
  const {
    components,
    modalAtencionConfig,
    Modal,
    SvgIconLoader,
    product,
    campaign
  } = props;
  const taggingInfo = {
    componentProduct: product || '',
    componentVariation: 'all',
    componentName: COMPONENT_NAME
  };
  const setUpModalProps = () => {
    Modal.setModalProps({
      contentPosition: 'right--center',
      opacityLayoutColor: 'black05',
      outSceneEffect: 'fadeOutRight',
      closeByClickingOutside: true,
      scrollAllowed: false
    });
  };
  const handleNewModal = () => {
    setUpModalProps();
    Modal.setContent( /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents4.default, {
      Modal: Modal,
      taggingInfo: _objectSpread({}, taggingInfo),
      SvgIconLoader: SvgIconLoader,
      campaign: campaign,
      product: product,
      tabsOptions: _objectSpread(_objectSpread({}, modalAtencionConfig), {}, {
        tabOptionPreChecked: 'solicitar-visita'
      })
    }));
    return Modal.show();
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("section", {
    className: "CounselingContact",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "container",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "wrapper-text",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "title",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
            kind: "heading",
            size: "title04",
            text: components.title,
            fontType: "font-regular",
            segment: "emp",
            color: "blue",
            align: "center",
            tabletProps: {
              size: 'display02',
              align: 'left'
            },
            desktopProps: {
              size: 'display02',
              align: 'left'
            }
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "subtitle",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
            kind: "span",
            size: "title05",
            display: "block",
            text: components.subtitle,
            fontType: "font-regular",
            color: "grey7",
            segment: "emp",
            align: "center",
            tabletProps: {
              size: 'title045',
              align: 'left'
            },
            desktopProps: {
              size: 'title045',
              align: 'left'
            }
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "wrapper-advantages",
          children: components.advantages.map(item => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "wrapper-advantage",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "wrapper-icon",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(SvgIconLoader, {
                id: item.icon,
                kind: "L",
                size: 22,
                segment: "emp",
                color: "blue"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
                ind: "span",
                size: "title06",
                text: item.textIcon,
                fontType: "font-regular",
                color: "blue",
                segment: "emp",
                align: "left",
                tabletProps: {
                  size: 'title045'
                },
                desktopProps: {
                  size: 'title045'
                }
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
                ind: "span",
                size: "title06",
                text: item.text,
                fontType: "font-regular",
                color: "grey7",
                segment: "emp",
                align: "left",
                tabletProps: {
                  size: 'title05'
                },
                desktopProps: {
                  size: 'title05'
                }
              })
            })]
          }))
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "wrapper-image visible-mobile",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, {
            src: components.urlImg
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "wrapper-button",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, {
            segment: "emp",
            label: "Te visitamos",
            buttonType: "button",
            onClick: handleNewModal,
            taggingInfo: _objectSpread(_objectSpread({}, taggingInfo), {}, {
              componentContent: 'Te visitamos'
            }),
            color: "blue",
            font: "bold",
            border: "no-border-radius",
            size: {
              w: 'full',
              h: 'large'
            },
            tabletProps: {
              size: {
                w: 'liquid'
              }
            },
            desktopProps: {
              size: {
                w: 'liquid'
              }
            }
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "wrapper-image visible-desktop",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, {
          src: components.urlImg
        })
      })]
    })
  });
};
CounselingContact.propTypes = {
  components: _propTypes.default.array.isRequired,
  modalAtencionConfig: _propTypes.default.object.isRequired,
  Modal: _propTypes.default.func.isRequired,
  SvgIconLoader: _propTypes.default.func.isRequired,
  product: _propTypes.default.string,
  campaign: _propTypes.default.string
};
var _default = exports.default = CounselingContact;

//# sourceMappingURL=index.js.map